module.exports = __webpack_public_path__ + "assets/terms.e540725d.png";